import React, { useState } from "react"
import {
  listActualitesHeader,
  listActualitesTitle,
  listActuFilters,
  listActuFiltersTaxo,
  actualiteDescription,
} from "./actualites.module.scss"
import { coverSpeed } from "../../../constants"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import {
  ListActualitesHeader,
  ListActuFiltersTaxo,
  AllBtn,
} from "./actualites-styled"
import { useActualites } from "gatsby-theme-blank/src/components/Home/Actualites/actualites-query"
import RenderActualites from "./RenderActualites/render-actualites"
import { getPublishedData } from "gatsby-theme-blank/src/components/get-published-data"

//-----------------------Parent component---------------------------//

const ListActualites = () => {
  const buildColors = useBuildData().theme_settings.palette
  const data = useActualites()
  const finalData = getPublishedData(data.allNodeActualites.edges).slice(0, 4)
  const [choosenTag, setChoosenTag] = useState("Tous")
  let allTaxos = finalData.map(({ node }) => {
    return node.relationships.field_taxonomie_thematique[0]?.name
  })
  allTaxos = [...new Set(allTaxos)]
  allTaxos.unshift("Tous")
  if (finalData.length === 0) {
    return null
  }
  return (
    <>
      <ListActualitesHeader className={listActualitesHeader}>
        <h2 className={listActualitesTitle}>
          {data.taxonomyTermZoneDefinie?.field_label || "À la une"}
        </h2>
        <div className={listActuFilters}>
          {allTaxos.map((taxo) => {
            let activeBool = false
            if (choosenTag === taxo) {
              activeBool = true
            }
            if (taxo === undefined) {
              return null
            }
            return (
              <ListActuFiltersTaxo
                activeBool={activeBool}
                key={taxo}
                onClick={() => {
                  setChoosenTag(taxo)
                }}
                className={listActuFiltersTaxo}
              >
                {taxo}
              </ListActuFiltersTaxo>
            )
          })}
        </div>
        <AllBtn
          cover
          direction="down"
          bg={buildColors.b_color_gradients.b_dark}
          duration={coverSpeed}
          className="btn"
          to="/actualites"
        >
          Tout voir
        </AllBtn>
      </ListActualitesHeader>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={actualiteDescription}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <RenderActualites
        colors={buildColors}
        actualiteData={finalData}
        choosenTag={choosenTag}
      />
    </>
  )
}
//-----------------------Parent component---------------------------//

export default ListActualites
